import { LiveFunctionCall } from '../GeminiLiveAPI/lib/multimodal-live-types'
import { CallServerToolCall } from './callServerTool'
import { DisplayMessageToUserToolCall } from './displayMessageToUser'
import { LoadAutoDesignResultToolCall } from './loadAutoDesignResult'
import { LoadBatteryDesignAssistantResultToolCall } from './loadBatteryDesignAssistantResult'
import { LoadInverterDesignAssistantResultToolCall } from './loadInverterDesignAssistantResult'
import { NavigateToolCall } from './navigate'
import { PreviewSubmitSiteVisitToolCall } from './previewSubmitSiteVisit'
import { RunAutoDesignToolCall } from './runAutoDesign'
import { RunAutoStringToolCall } from './runAutoString'
import { RunBatteryDesignAssistantToolCall } from './runBatteryDesignAssistant'
import { RunInverterDesignAssistantToolCall } from './runInverterDesignAssistant'
import { SaveSystemDesignAsTemplateToolCall } from './saveSystemDesignAsTemplate'
import { StopVoiceToolCall } from './stopVoice'
import { SystemEditToolCall } from './systemEdit'
import { UndoRedoToolCall } from './undoRedo'

export const toolHandlers = {
  navigate: NavigateToolCall,
  display_message_to_user: DisplayMessageToUserToolCall,
  preview_submit_site_visit: PreviewSubmitSiteVisitToolCall,
  load_auto_design_result: LoadAutoDesignResultToolCall,
  save_system_design_as_template: SaveSystemDesignAsTemplateToolCall,
  run_auto_design: RunAutoDesignToolCall,
  run_auto_string: RunAutoStringToolCall,
  run_battery_design_assistant: RunBatteryDesignAssistantToolCall,
  run_inverter_design_assistant: RunInverterDesignAssistantToolCall,
  load_battery_design_assistant_result: LoadBatteryDesignAssistantResultToolCall,
  load_inverter_design_assistant_result: LoadInverterDesignAssistantResultToolCall,
  system_edit: SystemEditToolCall,
  stop_voice: StopVoiceToolCall,
  undo_redo: UndoRedoToolCall,

  call_server_tool: CallServerToolCall,
  // Temporary way to route server-side tools to the correct tool handler.
  search_records: CallServerToolCall,
  submit_site_visit: CallServerToolCall,
  create_note_or_task: CallServerToolCall,
  proposal_data: CallServerToolCall,
  geocode_address: CallServerToolCall,
  create_or_update_project: CallServerToolCall,
  create_or_update_system_template: CallServerToolCall,
  lookup_component: CallServerToolCall,
}

// Allow both the specific History type and any compatible history object
export function callFunction(functionCall: LiveFunctionCall, history: any, orgId: number | undefined) {
  if (window.debugAdaActions) {
    console.log('[ADA DEBUG] Voice tool received:', {
      name: functionCall.name,
      args: functionCall.args,
      fullCall: functionCall,
    })
  }
  const handler = toolHandlers[functionCall.name]
  if (handler) {
    console.log(`tool found, calling: ${functionCall.name}`, functionCall)
    return handler(functionCall, history, orgId)
  } else {
    throw new Error(`Unknown tool call: ${functionCall.name}`)
  }
}
